import ExpressLogo from "./express.png";
import DataTablesLogo from "./datatables.png";
import SwagerLogo from "./swager.png";
import SQLLogo from "./sql.png";
import RestLogo from "./rest.png";
import PlotlyLogo from "./plotly.svg";
import PythonLogo from "./python.png";
import NodeLogo from "./node.png";
import JavaScriptLogo from "./javascript.svg";
import CSS3Logo from "./css3.svg";
import HTML5Logo from "./html5.svg";
import LinkedInLogo from "./linkedIn.png";
import BootstrapLogo from "./bootstrap.png";
import JadeLogo from "./jade.svg";
import FlaskLogo from "./flask.svg";
import GitHubLogo from "./github.png";
import EmailLogo from "./email.svg";
import ReactLogo from "./react.svg";
import DefaultLogo from "./default.svg";
import CodeLogo from "./code.svg";
import SASSLogo from "./sass.svg";
import SourceLogo from "./source-logo.svg";
import TypescriptLogo from "./typescriptlogo.svg";
import MongoDBLogo from "./mongodb-logo.svg";

export const Images = {
  ExpressLogo: { img: ExpressLogo, toolTip: "Express.js - back-end web application framework for Node.js" },
  DataTablesLogo: { img: DataTablesLogo, toolTip: "DataTables - Tables enchancing plugin for jQuery" },
  SwagerLogo: { img: SwagerLogo, toolTip: "Swagger - interface description language for documenting RESTful API's" },
  SQLLogo: { img: SQLLogo, toolTip: "SQL - Structured Query Language used in relational databases" },
  RestLogo: {
    img: RestLogo,
    toolTip: "REST - representational state transfer architectural style which uses a subset of HTTP",
  },
  PlotlyLogo: { img: PlotlyLogo, toolTip: "Plotly - interactive graphing library" },
  PythonLogo: { img: PythonLogo, toolTip: "Python - high level interpreted programming language" },
  NodeLogo: { img: NodeLogo, toolTip: "Node.js - standalone back-end JavaScript runtime environment" },
  JavaScriptLogo: { img: JavaScriptLogo, toolTip: "JS - JavaScript, high level JIT compiled programming languauge" },
  CSS3Logo: { img: CSS3Logo, toolTip: "CSS - Cascading Style Sheets" },
  HTML5Logo: { img: HTML5Logo, toolTip: "HTML5 markup language" },
  LinkedInLogo: { img: LinkedInLogo, toolTip: "View on LinkedIn", url: "https://www.linkedin.com/in/adamr-space/" },
  BootstrapLogo: { img: BootstrapLogo, toolTip: "Bootstrap front-end CSS framework" },
  JadeLogo: { img: JadeLogo, toolTip: "Jade templating engine for express" },
  FlaskLogo: { img: FlaskLogo, toolTip: "Flask micro web framework written in Python" },
  GitHubLogo: { img: GitHubLogo, toolTip: "GitHub source control", url: "https://github.com/adamr-space" },
  EmailLogo: { img: EmailLogo, toolTip: "e-mail icon", url: "" },
  ReactLogo: {
    img: ReactLogo,
    toolTip: "React is an open-source front-end JavaScript library for building user interfaces or UI components",
  },
  DefaultLogo: { img: DefaultLogo, toolTip: "Page logo" },
  CodeLogo: { img: CodeLogo, toolTip: "View source on GitHub" },
  SourceLogo: { img: SourceLogo, toolTip: "View source on GitHub" },
  SASSLogo: {
    img: SASSLogo,
    toolTip: "Sass is a preprocessor scripting language that is interpreted or compiled into Cascading Style Sheets",
  },
  TypescriptLogo: {
    img: TypescriptLogo,
    toolTip:
      "TypeScript is a programming language developed and maintained by Microsoft. It is a strict syntactical superset of JavaScript and adds optional static typing to the language.",
  },
  MongoDBLogo: {
    img: MongoDBLogo,
    toolTip:
      "MongoDB is a source-available cross-platform document-oriented database program. Classified as a NoSQL database program, MongoDB uses JSON-like documents with optional schemas.",
  },
};
